import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images/sus1.png'
import image2 from '../../images/TimiAndChuka.png'
import image3 from '../../images/Netzence.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/sus3.png'
function BlogPost3() {

     const blogs = [
    {
      id: 1,
      badge: "Global Footprint Network",
      badgeColor: "#7BC216",
      title: "Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building",
      description: "Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening...",
      source: "30/12/2025",
      image: image1,
      readMoreLink: "#"
    },
    {
      id: 2,
      badge: "Carbon Credit",
      badgeColor: "#3B3B3B",
      title: "Turning Lagos forests into climate revenue asset  Netzence",
      description: "In a bid to increase revenue for the country, Netzence sustainability Limited has said that baseline studies and carbon credits ",
      source: "18/09/2026",
      image: image2,
      readMoreLink: "#"
    },
    {
      id: 3,
      badge: "Climate change",
      badgeColor: "#00AED9",
      title: "Nigeria can turn climate crisis into $9bn opportunity – Netzence",
      description: "Netzence Sustainability Limited (Netzence) has said Nigeria can transform its social challenges into economic resilience by tapping into its CloseCarbon,a real-time carbon..",
      source: "03/07/2025",
      image: image3,
      readMoreLink: "#"
    }
  ];
  return (
<>

<Header/> 
<Link to="/blogs">
<div className='ml-72 text-[14px] flex pt-20'>
    Return to blog
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</div>
</Link>
<div className='ml-72 text-[24px] font-bold'>Netzence, Ministry of Livestock Development detect rapid seasonal Methane spikes in iivestock systems</div>
<div className='ml-72 flex gap-5 mt-10 '>
    <img loading='lazy' src={netzence} alt="netzence" className='w-[48px] h-[48px] object-cover'></img>


    <div>
        <div className='text-[16px] mb-3'>
            Netzence 
        </div>
        <div className='flex items-center gap-3 '>
            December 28, 2025 <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#898989"/>
</svg>
7 mins read
        </div>
    </div>


</div>
<div className='ml-72 mr-72 mt-20'>
    <img loading='lazy'src={sportlight} alt="spotlight" className='object-cover w-[1200px]'></img>
</div>

 <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto mt-20 ml-72" >
      {/* Paragraph 1 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Nigeria is finally beginning to see what has long remained hidden behind estimates and assumptions: how livestock methane emissions behave across regions, production systems, and seasons. </p>

      {/* Paragraph 2 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Preliminary field data emerging from an ongoing national monitoring programme led by Netzence Sustainability Limited (Netzence), in partnership with 3logy Limited and the Federal Ministry of Livestock Development (FMLD), shows measurable seasonal and regional differences in methane emissions within Nigerian livestock systems.</p>

      {/* Paragraph 3 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
This marks a decisive shift in the country’s ability to plan, finance, and verify climate action using evidence generated locally.</p>
      {/* Paragraph 4 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Early results indicate that livestock facilities monitored in Nigeria’s North-Central zone consistently exhibit higher methane-linked greenhouse gas emissions than comparable systems in the South-West. This directional pattern aligns with international research, which shows that livestock systems operating under hotter, more extensive, and open-grazing on average produced 10.82% higher enteric methane emissions than semi-intensive or better-buffered systems. According to Associate Professor Sadiq Sani, Founder and Chief Executive Officer of Netzence, the variations observed in the current dataset fall within the scientifically established ranges, even within the relatively short monitoring window covered so far.
</p>


{/* Paragraph 5 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
What distinguishes this programme is that it does not stop at identifying variation; it begins to explain it. The data reveals clear structural contrasts between the two regions. In the South-West, livestock production is dominated by semi-intensive and intensive systems, with herds comprising a higher proportion of young and mid-age animals, approximately 79.62%, alongside low to moderate daily movement. In contrast, North-Central systems are largely extensive and agro-pastoral, characterised by higher daily mobility and a greater share of mature animals, estimated at 54.87% of herd composition. From an emissions standpoint, mature cattle and sheep have larger rumen volumes and higher feed intake, resulting in greater baseline enteric methane output per head. This structural difference directly explains the higher emission intensity and variability observed in North-Central readings.
</p>

      {/* Paragraph 6 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Animal size further reinforces this trend. The dataset shows that cattle in South-West systems typically averaged a weight of 289.6 kilograms, compared to an average of 305 kilograms in North-Central herds. Sheep weights follow a similar pattern, averaging 37.5 kilograms in the South-West and 39.8 kilograms in the North-Central zone. Larger animals produce higher absolute methane emissions, and when this is combined with open-field exposure and extended grazing hours, measurable emission spikes emerge, particularly during periods of high activity and thermal stress.</p>

      {/* Paragraph 7 */}
      <p className=" font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Source
</p>

      {/* Paragraph 8 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
https://www.vanguardngr.com/2026/02/netzence-ministry-of-livestock-development-detect-rapid-seasonal-methane-spikes-in-iivestock-systems/ </p>

   
    
    </div>
   <div className="items-start gap-10 w-full max-w-[1200px] h-[43px] ml-72">
        <h2 
          className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[225px] h-[43px] mt-10"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

     <div className=" items-start gap-10 w-full max-w-[1201px] h-auto mt-20 ">
      {/* Header */}
   
      {/* Cards Container */}
      <div className="flex flex-row items-stretch gap-8 w-full flex-wrap ml-72 lg:flex-nowrap mb-20">
        {blogs.map((blog) => (
          <div 
            key={blog.id}
            className="flex flex-col items-center pb-6 gap-4 w-[379px] h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl shrink-0"
          >
            {/* Image */}
            <div className="w-[378px] h-[282px] rounded-t-2xl overflow-hidden">
              <img 
              loading='lazy'
                src={blog.image} 
                alt={blog.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Article Content */}
            <div className="flex flex-col items-start gap-4 w-[352px] h-[222px]">
              {/* Badge */}
              <div 
                className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded"
                style={{ backgroundColor: blog.badgeColor }}
              >
                <span 
                  className="text-white font-medium text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.badge}
                </span>
              </div>

              {/* Text Container */}
              <div className="flex flex-col items-start gap-3 w-full">
                {/* Title */}
                <h3 
                  className="text-[#3B3B3B] font-semibold text-[20px] leading-[24px] tracking-[-0.02em] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.title}
                </h3>
                
                {/* Description */}
                <p 
                  className="text-[#898989] font-normal text-[14px] leading-[20px] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.description}
                </p>
              </div>

              {/* Footer */}
              <div className="flex flex-row justify-between items-center w-full">
                <span 
                  className="text-[#3B3B3B] font-normal text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.source}
                </span>
                
                <a 
                  href={blog.readMoreLink}
                  className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                >
                  <span 
                    className="text-[#006633] font-medium text-[14px] leading-[20px]"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Read More
                  </span>
                  <div className="relative w-2.5 h-4 flex items-center justify-center">
                    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
<Footer/>
</>
  )
}

export default BlogPost3